// extracted by mini-css-extract-plugin
module.exports = {"commentFormPlaceholder":"_4DE-j","commentFormWrapper":"_1wZij","commentForm":"zj-NT"};